<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 id="alert-dialog" class="alert-title" mat-dialog-title>
    <div>{{dialogConfig.title}}</div>
</h2>
<mat-dialog-content id ="alert-contents" tabindex="-1" class="mat-typography">
    <p>{{dialogConfig.text}}</p>
    <form [formGroup]="form">
        <mat-form-field appearance="outline">
            <mat-label>{{'LI_PASSWORD' | translate}}</mat-label>
            <span style="display: flex;">
              <input matInput type="password" formControlName="password" name="re-enter-password"
                      (input)="tooltip?.show()" (capsLock)="onCapsLockChanged($event)"
                      (focus)="passwordFocus()" (blur)="passwordBlur()">
              @if (capsOn) {
                <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon" #tooltip="matTooltip"
                  matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right"></mat-icon>
              }
            </span>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="button-wrapper" align="end">
    <button mat-raised-button (click)="onCancelClick()" type="button" color="primary">{{'CANCEL' | translate}}</button>
    <button mat-raised-button (click)="onClickOK()" [disabled]="form.invalid" type="button" color="primary">{{'ALERT_OK' | translate}}</button>
</mat-dialog-actions>
